import { SidebarLayout } from "@/components/sidebar-layout";
import { PropsWithChildren } from "react";
import { MiraNavbar } from "./MiraNavbar";
import { MiraSidebar } from "./MiraSidebar";
import { UserData } from "@/lib/session/session-storage";

interface MiraSidebarLayoutProps extends PropsWithChildren {
  user: UserData;
  modules?: {
    absence_overview?: boolean;
    absence_requests?: boolean;
  };
}

export function MiraSidebarLayout({ user, modules, children }: MiraSidebarLayoutProps) {
  const session = { user };
  
  return (
    <SidebarLayout 
      navbar={<MiraNavbar session={session} />} 
      sidebar={<MiraSidebar session={session} modules={modules} />}
    >
      {children}
    </SidebarLayout>
  );
}
